
import { defineComponent } from "vue";
import StopWacth from "./StopWacth.vue";
export default defineComponent({
  name: "Timer-Component",
  components: { StopWacth },
  //esse atributo emite um evento, ou seja, avisa ao elemento pai que algo occoreu
  emits: ["finishedTimer"],
  data() {
    return {
      watcher: 0,
      timeSeconds: 0,
      checker: false,
    };
  },
  methods: {
    start() {
      this.checker = !this.checker;
      this.watcher = setInterval(() => {
        this.timeSeconds += 1;
      }, 1000);
    },
    end() {
      this.checker = !this.checker;
      clearInterval(this.watcher);
      this.$emit("finishedTimer", this.timeSeconds);
      this.timeSeconds = 0;
    },
  },
});
